<template>
  <div id="solidBackgroundMapAndHoursComponentLight" class="solid-background-map-and-hours-component footer-map-component"
    :data-theme="this.$store.state.chosenBrand" data-dark-color-is-primary="false">
    <div class="map-contact">
      <div class="container-fluid map-contact-container">
        <div class="row flex-row align-items-center">
          <div class="col-xs-12 col-md-6 col-content-map">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJVTN5Ty-NrIkRsduqeoK5jwQ&key=AIzaSyBqmPlt0BmYMsonE4paVkjJjsgW_Bmj-Ic"
                allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 col-content-location-and-hours">
            <div class="content-box">
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-12 col-content-location">
                  <div class="row dealer-location-info">
                    <div class="col-xs-12">
                      <h4 class="location-info-heading">Hometown Infiniti</h4>
                      <p class="location-info-address">11550 Common Oaks Drive #204, Raleigh, NC, 27614</p>
                    </div>
                  </div>
                  <div class="row contact-info">
                    <div class="col-xs-12">
                      <a href="#" class="btn contact-link contact-link--directions">
                        <i class="fa fa-map" aria-hidden="true"></i>
                        <span class="sr-only">Get Directions</span>
                      </a>
                      <a href="#" class="btn contact-link contact-link--phone">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <span class="sr-only">Call Us</span>
                      </a>
                      <div class="search-bar">
                      <form action="/vehicles" role="search">
                        <div class="input-group"><input aria-label="Search Bar" autocomplete="off" autocorrect="off"
                            class="form-control input-search" data-custom="false" data-placement="bottom"
                            data-search-suggestions="true" data-suggest="true" data-top="2025 INFINITI QX50"
                            name="query" placeholder="Schedule Service" spellcheck="false" title="Search this site..."
                            type="text" value=""><span class="input-group-btn"><button aria-label="search text"
                              class="btn btn-default no-border-left search-submit-btn" type="submit"><i
                                aria-hidden="true" class="fa fa-search"></i><span
                                class="alternate-btn-text hidden">Search</span></button><span
                              aria-label="pause automatic search suggest" aria-pressed="false"
                              class="btn btn-default toggleSearchText visuallyhidden" role="button" tabindex="0"></span></span></div>
                      </form>
                    </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-12 col-content-hours">
                    <div class="row">
                      <div class="col-xs-12 contact-hours">
                        <h5 class="hours-heading">Today's Hours</h5>
                        <p class="current-day-heading">
                          <span class="current-day-name">{{ currentDay }}</span>
                          <span class="spacer">&nbsp;&nbsp;</span>
                          <i class="fa fa-clock-o" aria-hidden="true"></i>
                        </p>
                        <p class="current-day-hours">
                          <span class="nav-hour nav-hour--sales">
                            <span class="category-delimiter"></span>
                            <span class="category-name">Sales</span>
                            <span class="hour hour-open">9</span>
                            <span class="field-delimiter"> - </span>
                            <span class="hour hour-close">7</span>
                          </span>
                          <span class="nav-hour nav-hour--service">
                            <span class="category-delimiter"></span>
                            <span class="category-name">Service</span>
                            <span class="hour hour-open">7:30</span>
                            <span class="field-delimiter"> - </span>
                            <span class="hour hour-close">5</span>
                          </span>
                        </p>
                        <a href="#" class="btn utility-link view-all-hours-link">
                          <span class="utility-link-text">Weekly Hours</span>
                          <span class="spacer">&nbsp;&nbsp;</span>
                          <i class="fa fa-chevron-right" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
</script>

<script>
  export default {
    name: "DayOfWeek",
    computed: {
      currentDay() {
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        return days[new Date().getDay()];
      },
    },
  };
</script>

<style scoped lang="scss">
  /* HAD TO ADD - BREAKING SITE OTEHRWISE*/
  #solidBackgroundMapAndHoursComponentLight {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    &::before, &::after {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .container-fluid {
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
      &::before {
        display: table;
        content: " ";
      }
    }
    .row {
      margin-right: -15px;
      margin-left: -15px;
      &::before {
        display: table;
        content: " ";
      }
      &::after {
        display: table;
        content: " ";
        clear: both;
      }
    }
    .col-xs-12 {
      width: 100%;
      float: left;
    }
    @media (min-width: 768px) {
     .col-sm-6 {
        width: 50%;
        float: left;
      }
    }
    @media (min-width: 992px) {
      .col-md-6 {
        width: 50%;
        float: left;
      }
      .col-md-12 {
        width: 100%;
        float: left;
      }
    }
    .col-md-6, .col-xs-12, .col-sm-6 {
      position: relative;
      min-height: 1px;
      padding-right: 15px;
      padding-left: 15px;
    }
    .embed-responsive {
      position: relative;
      display: block;
      height: 0;
      padding: 0;
      overflow: hidden;
    }
    .embed-responsive-16by9 {
      padding-bottom: 56.25%;
    }
    .embed-responsive iframe {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
    .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
      font-family: inherit;
      font-weight: 500;
      line-height: 1.1;
      color: inherit;
    }
    h4, .h4 {
      font-size: 18px;
    }
    h5, .h5 {
      font-size: 14px;
    }
    h4, .h4, h5, .h5 {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    p {
      margin: 0 0 10px;
    }
    .btn {
      display: inline-block;
      padding: 6px 12px;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.42857143;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      -ms-touch-action: manipulation;
      touch-action: manipulation;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background-image: none;
      border: 1px solid transparent;
      border-radius: 4px;
    }
    a {
      // color: #337ab7;
      // text-decoration: none;
      background-color: transparent;
    }
    .input-group {
      position: relative;
      display: table;
      border-collapse: separate;
    }
    .input-group .form-control:first-child, .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .input-group .form-control {
      display: table-cell;
    }
    .form-control {
      display: block;
      width: 100%;
      height: 34px;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      color: #555;
      background-color: #fff;
      background-image: none;
      border: 1px solid #ccc;
      border-radius: 4px;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
      -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
      transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
      transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
      transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    }
    .input-group .form-control {
      position: relative;
      z-index: 2;
      float: left;
      width: 100%;
      margin-bottom: 0;
    }
    .search-bar .input-search, .search-bar button {
      height: 50px;
      font-size: 20px;
    }
    button, input, select, textarea {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
      margin: 0;
      font: inherit;
      color: inherit;
    }
    input {
      line-height: normal;
    }
    .input-group-addon, .input-group-btn, .input-group .form-control {
      display: table-cell;
    }
    .input-group-addon, .input-group-btn {
      width: 1%;
      white-space: nowrap;
      vertical-align: middle;
    }
    .input-group-btn {
      position: relative;
      font-size: 0;
      white-space: nowrap;
    }
    .input-group-btn:last-child>.btn-group, .input-group-btn:last-child>.btn {
      z-index: 2;
      margin-left: -1px;
    }
    .input-group-btn>.btn {
      position: relative;
    }
    .hidden {
      display: none !important;
    }
    .input-group-btn>.btn+.btn {
      margin-left: -1px;
    }
  }
</style>

<style scoped>

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .contact-hours {
    padding: 0;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-search:focus {
    outline: none;
  }

  /* Custom Properties */

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight {
    --pc: var(--primary-color, #333333);
    --pcd: var(--primary-dark, #000000);
    --pcl: var(--primary-light, #ffffff);
  }

  /* Utilities */

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .btn {
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .utility-link {
    color: var(--pcd, #000000);
    border: 0;
    border-radius: 0;
    border-bottom: solid 1px;
    border-bottom-color: var(--pcd, #000000);
    padding: 5px 0;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .utility-link:hover, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .utility-link:active, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .utility-link:focus {
    opacity: 0.7;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
  
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .align-items-center {
    align-items: center;
  }

  /* General */

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact {
    background-color: var(--primary-light, #333333);
    color: var(--pcd, #000000);
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight[data-theme="infiniti"] .map-contact {
    background-color: var(--secondary-light, #333333);
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact-container {
    max-width: 1400px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact .content-box {
    padding: 30px 0;
    margin: auto;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact h4,
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact h5,
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact .contact-link {
    text-transform: uppercase;
    font-family: var(--heading-text) !important;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact p,
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact .contact-link {
    font-size: 13px;
    font-weight: 400;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact .location-info-address {
    margin: 15px 0px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact .hours-heading {
    margin-top: 30px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact .contact-hours p, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact h4 {
    margin-bottom: 5px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .nav-hour, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .nav-hour:not(:first-child) .category-delimiter {
    margin-right: 7px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .nav-hour {
    display: inline-block;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .nav-hour span:not(.category-name) {
    font-size: 16px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .nav-hour .category-name {
    color: var(--pcd, #000000);
    opacity: 0.7;
    padding-right: 5px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .contact-link, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar {
    margin-bottom: 10px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .contact-link {
    padding: 9px 10px 7px 10px;
    margin-right: 10px;
    color: var(--pcd, #000000);
    border: solid 1px;
    border-color: var(--pcd, #000000);
    border-radius: 100%;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .contact-link:hover, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .contact-link:active, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .contact-link:focus {
    color: var(--pcl, #ffffff);
    background-color: var(--pcd, #000000);
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .contact-link .fa {
    font-size: 17px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .view-all-hours-link {
    margin-top: 15px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .view-all-hours-link .fa {
    font-size: 11px;
  }

  /* Search Bar */

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar {
    display: inline-block;
    vertical-align: middle;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-search {
    background-color: transparent;
    color: var(--pcd, #000000);
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-search::placeholder {
    color: var(--pcd, #000000);
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-group-btn .search-submit-btn {
    background-color: transparent;
    color: var(--pcd, #000000);
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-group-btn .search-submit-btn:hover, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-group-btn .search-submit-btn:active, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-group-btn .search-submit-btn:focus {
    background-color: var(--pcd, #000000);
    color: var(--pcl, #ffffff);
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }

  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar .input-search, 
  .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .search-bar button {
    font-size: 14px;
    height: 40px;
    border-color: var(--pcd, #000000);
  }
  span.btn.btn-default.toggleSearchText.visuallyhidden {
    display: none;
  }

  @media (min-width: 992px) {
    
    .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact .content-box {
      padding: 30px;
      max-width: 460px;
    }

  }

  @media (min-width: 768px) and (max-width: 991px) {

    .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .map-contact .hours-heading {
      margin-top: 10px;
    }

    .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .view-all-hours-link {
      margin-top: 0;
    }

  }

  @media (max-width: 991px) {
    
    .layout.row[data-component="Solid Background Map and Hours Light"] #solidBackgroundMapAndHoursComponentLight .nav-hour .category-delimiter {
      display: none;
    }

  }
</style>